
const m = window.require("discourse/components/d-modal");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
